(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/init.js');
'use strict';

svs.tickets.init = () => {
  var _appTimeline$add, _svs$tickets$data;
  svs.tickets.logger = new svs.core.log.Logger('module:tickets');
  const {
    matchPath,
    PlayerRouter
  } = svs.app.ReactRouter;
  const {
    useEffect,
    useState
  } = React;
  const {
    PICK_PATH,
    PLAY_PATH
  } = svs.tickets.play.utils.constants;
  const Route = svs.app.ReactRouter.Route;
  const Menu = svs.tickets.play.components.Menu;
  const baseUrl = svs.core.data.baseUrl;
  const PlayContainer = svs.tickets.play.containers.PlayContainer;
  const GameLauncherWrapper = svs.tickets.play.containers.GameLauncherWrapper;
  const availableTickets = svs.tickets.data.moduleConfig.availableTickets;
  const {
    getTicketInfo,
    getMenuProduct
  } = svs.tickets.play.utils.utils;
  const Background = svs.tickets.play.components.Background;
  const {
    useTicketContext,
    TicketProvider
  } = svs.tickets.play.utils.context;
  const HiddenRoute = svs.tickets.play.containers.HiddenRoute;
  const {
    listener,
    setPaused
  } = svs.tickets.play.utils.TicketListener();
  const appTimeline = new gsap.timeline();
  gsap.ticker.lagSmoothing(0);
  appTimeline.addLabel('showUsp', 0);
  appTimeline.addLabel('hideUsp', 2);
  appTimeline.addLabel('gameReady', 3);
  appTimeline.addLabel('introDone', 5);
  appTimeline === null || appTimeline === void 0 || (_appTimeline$add = appTimeline.add) === null || _appTimeline$add === void 0 || _appTimeline$add.call(appTimeline, () => {}, 'gameReady'); 

  const menuProducts = availableTickets.filter(p => p.open);
  const DispatcherRoute = _ref => {
    let {
      children,
      isMatch
    } = _ref;
    const [dispatcherProps, setDispatcherProps] = useState(undefined);
    const [wasMatch, setWasMatch] = useState(false);
    useEffect(() => {
      if (isMatch === false && wasMatch === true) {
        setDispatcherProps(undefined);
      }
      setWasMatch(isMatch);
    }, [isMatch]);
    useEffect(() => {
      window.addEventListener('PRELOAD_TICKET', _ref2 => {
        let {
          detail
        } = _ref2;
        setDispatcherProps(detail);
        setPaused(true);
      });
    }, []);
    return isMatch || dispatcherProps ? React.createElement(React.Fragment, null, React.Children.map(children, child => React.cloneElement(child, dispatcherProps))) : null;
  };
  const hasUnscratchedTicket = ((_svs$tickets$data = svs.tickets.data) === null || _svs$tickets$data === void 0 ? void 0 : _svs$tickets$data.fetchedGames) && svs.tickets.data.fetchedGames.length > 1;
  const router = React.createElement(PlayerRouter, {
    basename: baseUrl,
    withRouter: true
  }, React.createElement(Background, null), React.createElement(Menu, {
    appTimeline: appTimeline,
    products: menuProducts
  }), React.createElement(Route, {
    component: _ref3 => {
      var _ticketInfo2;
      let {
        match,
        history
      } = _ref3;
      const {
        updateTicketInfo
      } = useTicketContext();
      const routeMatch = matchPath(match.url, {
        path: PLAY_PATH,
        exact: true,
        strict: false
      });
      const ticketInfoMatch = matchPath(history.location.pathname, {
        path: [PICK_PATH, PLAY_PATH]
      });
      let wagerId;
      let skinId;
      let ticketInfo;
      let ticketNumber;
      let demo;
      if (routeMatch) {
        var _ticketInfo;
        wagerId = routeMatch.params.wagerId.toLowerCase();

        const sameAlternativeUrlTicketTypes = availableTickets.filter(ticket => {
          var _ticket$alternativeUr;
          return ((_ticket$alternativeUr = ticket.alternativeUrl) === null || _ticket$alternativeUr === void 0 ? void 0 : _ticket$alternativeUr.toLowerCase()) === routeMatch.params.ticketType;
        }).map(ticket => ticket.type.toLowerCase());
        const ticketTypes = sameAlternativeUrlTicketTypes.length > 0 ? sameAlternativeUrlTicketTypes : [routeMatch.params.ticketType.toLowerCase()];
        ticketInfo = availableTickets.find(ticket => ticketTypes.includes(ticket.type.toLowerCase()));
        ticketNumber = parseInt(svs.utils.paramHandler.get({
          key: 'ticketNumber'
        }).value, 10) || null;
        demo = wagerId === 'demo';
        skinId = (_ticketInfo = ticketInfo) !== null && _ticketInfo !== void 0 && _ticketInfo.defaultSkin ? 1 : svs.utils.paramHandler.get({
          key: 'skinId'
        }).value;
      }
      setPaused(false);
      const onClose = e => {
        var _appTimeline$pause, _appTimeline$seek;
        e === null || e === void 0 || e.preventDefault();
        appTimeline === null || appTimeline === void 0 || (_appTimeline$pause = appTimeline.pause) === null || _appTimeline$pause === void 0 || _appTimeline$pause.call(appTimeline);
        appTimeline === null || appTimeline === void 0 || (_appTimeline$seek = appTimeline.seek) === null || _appTimeline$seek === void 0 || _appTimeline$seek.call(appTimeline, 'gameReady');
        history.push("../../valja/".concat(ticketInfoMatch.params.ticketType));
      };
      const props = {
        appTimeline,
        demo,
        hasUnscratchedTicket,
        history,
        onClose,
        skinId,
        ticketInfo,
        ticketNumber,
        wagerId,
        listener
      };
      useEffect(() => {
        updateTicketInfo(ticketInfo);
      }, [(_ticketInfo2 = ticketInfo) === null || _ticketInfo2 === void 0 ? void 0 : _ticketInfo2.type]);
      return React.createElement(HiddenRoute, {
        displayPath: PLAY_PATH,
        url: match.url
      }, React.createElement(DispatcherRoute, {
        isMatch: Boolean(routeMatch)
      }, React.createElement(GameLauncherWrapper, props)));
    },
    path: "*"
  }), React.createElement(Route, {
    component: _ref4 => {
      let {
        match,
        history
      } = _ref4;
      const {
        updateTicketInfo
      } = useTicketContext();
      const {
        ticketType,
        wagerId,
        gameIsCompleted
      } = svs.tickets.play.utils.utils.getTicketTypeFromWager(match.params.wagerId);
      const onClose = e => {
        e === null || e === void 0 || e.preventDefault();
        window.location.href = svs.core.urlMapping.get('myBetsHome');
      };
      const ticketInfo = getTicketInfo(ticketType, svs.tickets.data.scratchTickets);
      const props = {
        appTimeline,
        gameIsCompleted,
        demo: false,
        hasUnscratchedTicket,
        history,
        onClose,
        ticketInfo,
        wager: svs.tickets.data.fetchedGame,
        wagerId
      };
      useEffect(() => {
        updateTicketInfo(ticketInfo);
      }, [ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type]);
      return React.createElement(GameLauncherWrapper, props);
    },
    exact: true,
    path: "/mina-spel/:wagerId"
  }), React.createElement(Route, {
    component: _ref5 => {
      let {
        match
      } = _ref5;
      const {
        updateTicketInfo
      } = useTicketContext();
      const ticketType = match.params.ticketType;
      const ticketInfo = getMenuProduct(ticketType, menuProducts);
      if (ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.defaultSkin) {
        ticketInfo.variations = 1;
      }
      appTimeline.pause();
      if (!ticketInfo || !ticketInfo.type) {
        window.location.href = "../valja/".concat(menuProducts[0].type);
        return React.createElement("div", null);
      }
      useEffect(() => {
        var _svs$tickets$data$mod;
        updateTicketInfo(ticketInfo);
        const moduleTitle = (_svs$tickets$data$mod = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod === void 0 ? void 0 : _svs$tickets$data$mod.moduleTitle;
        const title = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.title) || moduleTitle;
        if (title) {
          document.title = title;
        }
      }, [ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type]);
      return React.createElement(PlayContainer, {
        appTimeline: appTimeline,
        history: history,
        setPaused: setPaused,
        ticketInfo: ticketInfo
      });
    },
    exact: true,
    path: "/valja/:ticketType"
  }));
  ReactDOM.render(React.createElement(TicketProvider, null, router), document.getElementById('reactContainer'));
};
svs.tickets.init();

 })(window);